var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('photos',{attrs:{"photos":_vm.actif},on:{"clicked":_vm.clic}}),_c('overlay',{attrs:{"show":_vm.show,"image":_vm.imgsel,"titre":_vm.titre,"serie":_vm.serie,"total":_vm.total},on:{"closed":_vm.close}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }